import { isObject } from 'xe-utils'
import { subAppUrlToBaseUrl } from '..'
import { addPageTagAndNavigate, addPageTagAndNavigateBySubAppUrl, messageWrapper, postMessageToParentTag, showParentTag, tagCloseSelf } from '../pageTagUtils'
import { isAppInnerUrl } from '../utils'
import { COMPOSE_ACTIONS_TYPE_ENUM } from './messageType'

const actionInfoMap = {
  [COMPOSE_ACTIONS_TYPE_ENUM.closeSelf]: {
    handler: (options = {}, fullPayload = {}) => {
      tagCloseSelf({
        tagId: fullPayload.tagId,
      })
    },
  },
  [COMPOSE_ACTIONS_TYPE_ENUM.message]: {
    handler: (options = {}, fullPayload = {}) => {
      messageWrapper(options)
    }
  },
  [COMPOSE_ACTIONS_TYPE_ENUM.addTagAndGo]: {
    handler: (options = {}, fullPayload = {}) => {
      const { fullUrl, title, ...restOptions } = options

      addPageTagAndNavigateBySubAppUrl(fullUrl, title, restOptions)
    }
  },
  [COMPOSE_ACTIONS_TYPE_ENUM.showParentTag]: {
    handler: (options = {}, fullPayload = {}) => {
      showParentTag(fullPayload.tagId, options)
    }
  },
  [COMPOSE_ACTIONS_TYPE_ENUM.postMessageToParentTag]: {
    handler: (options = {}, fullPayload = {}) => {
      postMessageToParentTag(fullPayload.tagId, options)
    }
  },
  [COMPOSE_ACTIONS_TYPE_ENUM.parentHistoryGo]: {
    handler: (options = {}, fullPayload = {}) => {
      const { dest = -1 } = options
      window.history.go(dest)
    }
  },
}

async function exeAction(action = {}, fullPayload = {}) {
  const { tagId } = fullPayload
  const { type, options } = action

  const actionInfo = actionInfoMap[type]

  if (actionInfo.handler) {
    console.log(`base-app composeAction handler type: ${type}`)
    await actionInfo.handler(options, fullPayload)
  }
}

export async function composeActions(fullPayload = {}) {
  // payload: { tagId, actions: [] }
  const { tagId, actions = [] } = fullPayload
  for (let index = 0; index < actions.length; index++) {
    const action = actions[index]
    await exeAction(action, fullPayload)
  }
}
